import React from 'react';
import { Autocomplete, Box, TextField, styled } from '@mui/material';
import { useSearchParam } from 'helpers/useSearchParam';
import { useJobsContext } from 'components/JobList';

const FilterField = styled(Box)({
  minWidth: 160,
  flex: '1 1 160px',
  maxWidth: 240
});

export default function SelectCompany() {
  const { onCompanyChange, companies } = useJobsContext();
  const [company] = useSearchParam('company');

  const options = (companies || []).map((companyName) => ({
    value: companyName || 'no-company',
    label: companyName || 'No company in job'
  }));

  const selected = options.find((option) => option.value === company) || null;

  return (
    <FilterField>
      <Autocomplete
        clearOnEscape
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, selectedValue) =>
          option.value === selectedValue.value
        }
        onChange={(_event, next) => onCompanyChange(next?.value || '')}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Company"
            placeholder="Search company"
            size="small"
          />
        )}
        size="small"
        value={selected}
      />
    </FilterField>
  );
}
